<template>
  <div class="" @click.stop="()=>{}">
    <v-select
      :options="inquiryStatuses"
      v-model="newStatus"
      :placeholder="$t('inquiryStatusSelect.orderStatus')"
      :clearable="false"
      :searchable="false"
      :reduce="(status) => status.value"
      :disabled="disabled"
      :noDrop="isCustomer"
      label="text"
      :class="{
        'f-badge-select mb-0': true,
        'no-drop': isCustomer
      }">
      <template
        slot="option"
        slot-scope="option">
        <f-badge
          :theme="option.value.toLowerCase().replaceAll('_', '-')">
          {{ option.text }}
        </f-badge>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <f-badge
          :counter="statusAt"
          :theme="option.value.toLowerCase().replaceAll('_', '-')">
          {{ option.text }}
        </f-badge>
      </template>
    </v-select>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import InquiryStatuses from '@/data/inquiry-statuses.js';

export default {
  name: 'inquiry-status-select',
  props: {
    inquiryID: {
      type: [String, Number],
      required: true
    },
    status: {
      type: String
    },
    statusAt: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isCustomer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inquiryStatuses () {
      return InquiryStatuses
    }
  },
  data () {
    return {
      currentStatus: null,
      newStatus: null,
      loadError: false,
    }
  },
  watch: {
    newStatus (newValue) {
      if (newValue && newValue !== this.currentStatus) {
        this.submitStatus();
      }
    }
  },
  mounted() {
    Vue.set(this, 'currentStatus', this.status);
    Vue.set(this, 'newStatus', this.status);
  },
  methods: {
    submitStatus () {
      let formDataToSend = {
        inquiry_id: this.inquiryID,
        status: this.newStatus
      };

      FormUtils.submitWithConfirm(this, {
        endpoint: '/api/adviser/inquiries/statuses/store',
        formData: formDataToSend,
        successTitle: this.$t('inquiryStatusSelect.savedStatus'),
        successText: this.$t('inquiryStatusSelect.StatusHasBeenSaved'),
        confirmTitle: this.$t('inquiryStatusSelect.areYouSureYouWantToChangeTheStatusOfTheOffer'),
        confirmText: this.$t('ui.thisOperationCannotUndone'),
        confirmButtonText: this.$t('ui.yesChange'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('inquiryStatusSelect.modifyStatusError'),
        successAction: () => {
          Vue.set(this, 'currentStatus', this.newStatus);
        },
        failAction: () => {
          this.newStatus = this.currentStatus;
        },
        cancelAction: () => {
          this.newStatus = this.currentStatus;
        }
      });
    }
  }
}
</script>
